import { difference } from 'lodash';
import { useMemo } from 'react';

import { useLoggedInUserRoles } from '~/components/Auth';
import { RoleGroups, getRoleGroups } from '~/services/Permissions';

import { WidgetsPerspective } from '../models';

type RoleGroupsToPerspectivesMapping = {
  [key in RoleGroups]: WidgetsPerspective;
};

export const roleGroupsToPerspectivesMapping: RoleGroupsToPerspectivesMapping =
  {
    [RoleGroups.EMPLOYEE]: WidgetsPerspective.EMPLOYEE,
    [RoleGroups.STRAIGHT_MANAGER]: WidgetsPerspective.MANAGER,
    [RoleGroups.RESPONSIBLE_MANAGER]: WidgetsPerspective.RESPONSIBLE_MANAGER,
    [RoleGroups.HR]: WidgetsPerspective.RESPONSIBLE_HR,
  };

export const useAvailablePerspectives = (
  prohibitedPerspectives?: WidgetsPerspective[],
) => {
  const roles = useLoggedInUserRoles();

  return useMemo(() => {
    const allowedPerspectives = getRoleGroups(roles).map((roleGroup) => {
      return roleGroupsToPerspectivesMapping[roleGroup];
    });

    return difference(allowedPerspectives, prohibitedPerspectives || []);
  }, [prohibitedPerspectives, roles]);
};
